import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'positiveNumber',
    standalone: false
})
export class PositiveNumberPipe implements PipeTransform {
  transform = (value: number) => {
    return Math.abs(value);
  };
}
